import React from 'react';
import { Link } from 'react-router-dom';
import style from './Breadcrumbs.module.css';

/**
 * items: [{ label: string, to?: string }] — el último item sin `to` se renderiza como texto actual.
 */
const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <nav className={style.breadcrumbs} aria-label="breadcrumb">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${idx}`}>
            {idx > 0 && <span className={style.separator}>/</span>}
            {item.to && !isLast ? (
              <Link to={item.to} className={style.link}>
                {item.label}
              </Link>
            ) : (
              <span className={style.current}>{item.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
